import { createLogic } from "redux-logic";
import { TRACK_AUTH_STATUS } from "../types";
import { authStatusChanged, setAppUser, frontEndLoginSuccess, frontEndSetUser } from "../actions";
import firebaseApp from "../../../firebase";
import firebaseAuthApp from "../../../authFirebase";
// Replace Firebase namespace import with modular imports
import { getAuth, onAuthStateChanged } from "firebase/auth";

const trackAuthStatusLogic = createLogic({
	type: TRACK_AUTH_STATUS,
	latest: true,
	warnTimeout: 0,
	// eslint-disable-next-line no-unused-vars
	process({ action }, dispatch, done) {
		// Get auth instances using getAuth()
		const auth = getAuth(firebaseApp);
		
		// Use onAuthStateChanged as a standalone function
		onAuthStateChanged(auth, user => {
			dispatch(authStatusChanged({ user }));
			if (user === null) {
				dispatch(setAppUser(undefined));
			}
		});
		
		onAuthStateChanged(firebaseAuthApp, user => {
			if (user) {
				dispatch(frontEndLoginSuccess(user));
			} else {
				dispatch(frontEndSetUser(undefined));
			}
		});
	},
});

export default [trackAuthStatusLogic];
